import React from 'react';
import { Card, EmptyValue, Table } from '@/components/ui';
import type { Vehicle } from '../../../types/Vehicle';
import { formatDateTime } from '../../../utils/wrapDate';
import { historyChangedBy, historyComment, historyFieldLabel, historyValue } from '../utils/equipmentHistory';

/** Audit History (EQ-25): one title, on a white card, in plain language. */
const EquipmentAuditHistoryTab: React.FC<{ vehicle: Vehicle }> = ({ vehicle }) => {
  const rows = [...(vehicle.vehicleHistory ?? [])].sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  );
  return (
    <Card>
      <Card.Header>
        <h2 className="tw-mb-0 tw-text-base tw-font-semibold">Audit History</h2>
      </Card.Header>
      <Card.Body className="tw-p-0">
        {rows.length === 0 ? (
          <p className="tw-mb-0 tw-p-4 tw-text-sm tw-text-content-muted">No changes recorded yet.</p>
        ) : (
          <Table responsive className="tw-mb-0">
            <thead>
              <tr>
                <th>Date</th>
                <th>Field</th>
                <th>Old Value</th>
                <th>New Value</th>
                <th>Changed By</th>
                <th className="tw-min-w-[16rem]">Comments</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((entry) => {
                const comment = historyComment(entry.comments);
                return (
                  <tr key={entry.id}>
                    <td className="tw-whitespace-nowrap">{formatDateTime(entry.createdAt) ?? <EmptyValue />}</td>
                    <td className="tw-whitespace-nowrap">{historyFieldLabel(entry.field)}</td>
                    <td className="tw-whitespace-pre-wrap">{historyValue(entry.field, entry.oldValue)}</td>
                    <td className="tw-whitespace-pre-wrap">{historyValue(entry.field, entry.newValue)}</td>
                    <td className="tw-whitespace-nowrap">{historyChangedBy(entry)}</td>
                    <td className="tw-whitespace-pre-wrap">{comment || <EmptyValue />}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        )}
      </Card.Body>
    </Card>
  );
};

export default EquipmentAuditHistoryTab;
